import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateProvisionedDeviceImplementorMutationVariables = Types.Exact<{
  phoneNumber: Types.Scalars['String']['input'];
  newMacAddress: Types.Scalars['String']['input'];
  vendorId: Types.Scalars['Int']['input'];
  currentMacAddress?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateProvisionedDeviceImplementorMutation = { __typename?: 'Mutation', updateProvisionedDeviceImplementor?: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };


export const UpdateProvisionedDeviceImplementorDocument = gql`
    mutation UpdateProvisionedDeviceImplementor($phoneNumber: String!, $newMacAddress: String!, $vendorId: Int!, $currentMacAddress: String) {
  updateProvisionedDeviceImplementor(
    phoneNumber: $phoneNumber
    newMacAddress: $newMacAddress
    vendorId: $vendorId
    currentMacAddress: $currentMacAddress
  ) {
    id
    errors {
      location
      context
      type
    }
  }
}
    `;
export type UpdateProvisionedDeviceImplementorMutationFn = Apollo.MutationFunction<UpdateProvisionedDeviceImplementorMutation, UpdateProvisionedDeviceImplementorMutationVariables>;

/**
 * __useUpdateProvisionedDeviceImplementorMutation__
 *
 * To run a mutation, you first call `useUpdateProvisionedDeviceImplementorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProvisionedDeviceImplementorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProvisionedDeviceImplementorMutation, { data, loading, error }] = useUpdateProvisionedDeviceImplementorMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      newMacAddress: // value for 'newMacAddress'
 *      vendorId: // value for 'vendorId'
 *      currentMacAddress: // value for 'currentMacAddress'
 *   },
 * });
 */
export function useUpdateProvisionedDeviceImplementorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProvisionedDeviceImplementorMutation, UpdateProvisionedDeviceImplementorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProvisionedDeviceImplementorMutation, UpdateProvisionedDeviceImplementorMutationVariables>(UpdateProvisionedDeviceImplementorDocument, options);
      }
export type UpdateProvisionedDeviceImplementorMutationHookResult = ReturnType<typeof useUpdateProvisionedDeviceImplementorMutation>;
export type UpdateProvisionedDeviceImplementorMutationResult = Apollo.MutationResult<UpdateProvisionedDeviceImplementorMutation>;
export type UpdateProvisionedDeviceImplementorMutationOptions = Apollo.BaseMutationOptions<UpdateProvisionedDeviceImplementorMutation, UpdateProvisionedDeviceImplementorMutationVariables>;